export const environment = {
    production: false,
    apiUrl: 'https://test-api-event.vlinkgroup.net/api'
};
